<template lang="pug">
.intro
  .title {{$t('introduction.title')}}
  .subtitle {{$t('introduction.subtitle')}}
  intro-slides(:activeCard="id")

</template>
<script>
import IntroSlides from '@/components/intro/IntroSlides'
export default {
  name: 'Intro',
  components: { IntroSlides },
  props: {
    id: {
      default: -1,
    },
  },
  data() {
    return {}
  },
  watch: {
    id(val) {
      console.log('!!!', val)
    },
  },
  computed: {},
  methods: {},
  mounted() {
    console.log('!!!', this.id, this.$router, this.$route)
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.intro
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
  padding: 0 pxToRem(30)
  //height: pxToRem(200)
  //background: #3a54a2
  background: #FFFFFF
  color: black
  overflow: hidden
  //display: flex
  //flex-direction: column
  //justify-content: space-between
  .intro-slides
    margin-top: pxToRem(115)
</style>
